module.exports = __webpack_public_path__ + "img/client-4.7e1b062a.webp";